import React from 'react'

import {
  ContentfulSizeChart,
  ContentfulSizeChartSection,
} from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import { TAB_STATES } from '../../sizeGuide/sizeGuideOne/SizeGuideOne'
import styles from '../sizeChart.module.scss'

import SizeChartUnitsToggle from './SizeChartUnitsToggle.component'

interface SizeChartHeaderProps {
  activeTab: TAB_STATES
  activeSizeChart: ContentfulSizeChart
  selectedSizeChartSection?: ContentfulSizeChartSection
  sizeChartSections: ContentfulSizeChartSection[]
  isMergedSizeChart: boolean
  onUnitsToggle: () => void
  isUnitsToggleActive: boolean
  hideUnitsTitle?: boolean
}

const SizeChartHeader = (props: SizeChartHeaderProps) => {
  const headerTitle = props.activeSizeChart.title
  const shouldShowUnitsToggle =
    props.sizeChartSections.length > 1 && props.activeTab !== TAB_STATES.INTERNATIONAL_CONVERSIONS
  const shouldShowUnitsTitle =
    !props.hideUnitsTitle && props.selectedSizeChartSection?.title && !props.isMergedSizeChart
  const unitsTitle = props.selectedSizeChartSection?.title

  return (
    <>
      <div className={styles.container__header}>
        <div className={styles.container__header__title}>{headerTitle}</div>
        {shouldShowUnitsToggle && (
          <SizeChartUnitsToggle
            sizeChartSections={props.sizeChartSections}
            isUnitsToggleActive={props.isUnitsToggleActive}
            onUnitsToggle={props.onUnitsToggle}
          />
        )}
      </div>
      {shouldShowUnitsTitle && <p className={styles.container__sectionTitle}>{unitsTitle}</p>}
    </>
  )
}

export default SizeChartHeader
